import { OpportunitiesConst } from '@axiom/const'; // eslint-disable-line project-structure/folder-structure

import selectifyUtil from '../utils/selectify-util';

export const HOME_OFFICES_API_NAME = 'Home Offices API';
export const JOB_API_NAME = 'Jobs API';
export const NOTIFICATIONS = 'Notifications';
export const TALENT_API_NAME = 'Talent API';

export const TAG_TYPE = {
  TAG: 'tag',
  SKILL: 'skill',
  INDUSTRY: 'industry',
  LAW_SCHOOL_RANK: 'lawSchoolRank',
};

export const JOBS_FORM = 'jobs';
export const TALENT_FORM = 'talent';
export const BENCH_FORM = 'benchTalent';

export const ALL = 'all';
export const ACCOUNT_MANAGER_OWNER_OR_SALES_LEAD =
  'accountManagerOwnerOrSalesLead';
export const OWNER = 'owner';
export const COLLABORATOR = 'collaborator';
export const TEAM = 'team';
export const PARALEGAL = 'Paralegal';

export const TALENT_FILTER_OPTIONS = [
  {
    label: 'Owned By Me',
    value: OWNER,
  },
  {
    label: 'Collaborating On',
    value: COLLABORATOR,
  },
];
export const DEFAULT_MAX_HOURS = {
  maxHours: '50',
};

// Fields
export const TAGS = 'tags';
export const LANGUAGES = 'languages';

const {
  Validate,
  Develop,
  Intake,
  Contract,
  Compete,
  Craft,
  ClosedWon,
  ClosedLost,
} = OpportunitiesConst.Stages;

export const VALIDATE = Validate;
export const DEVELOP = Develop;
export const INTAKE = Intake;
export const CONTRACT = Contract;
export const COMPETE = Compete;
export const CRAFT = Craft;
export const CLOSED_WON = ClosedWon;
export const CLOSED_LOST = ClosedLost;

export const EDITABLE_OPPORTUNITY_STATUS_BLACKLIST = new Set([
  CLOSED_WON,
  CLOSED_LOST,
]);

export const TALENT_MIN_COMPENSATION_RATE = 0;
export const TALENT_MAX_COMPENSATION_RATE = 2250000;

export const TALENT_MIN_YEARS_OF_EXPERIENCE = 0;
export const TALENT_MAX_YEARS_OF_EXPERIENCE = 50;
